export default __webpack_public_path__ + "static/media/arras02.1b97f9df.jpg";